import actions from '../../constants/actionTypes';
import { handleCloseDialogGeneric } from '../../redux/genericReducerHandler';
import { EnumBellSound, EnumLanguage, EnumPage } from '../../constants/enum';

const initialState = {
  language: EnumLanguage.VIETNAM.value,
  currentRestaurant: {},
  isChangeRestaurant: false,
  notificationBell: {
    ringBellSound: EnumBellSound.NORMAL.id,
    isRingBell: false,
    listNotifications: [],
    isRingAllRestaurant: false,
  },
};

function settingsReducer(state = initialState, action) {
  const { response, type } = action;
  const PAGE = EnumPage.SETTING.id;
  switch (type) {
    case actions.CLOSE_DIALOG_GENERIC: {
      return handleCloseDialogGeneric(PAGE, state, action);
    }
    case actions.CHANGE_LANGUAGE: {
      return {
        ...state,
        language: response,
      };
    }
    case actions.SET_CURRENT_RESTAURANT: {
      return {
        ...state,
        currentRestaurant: response,
      };
    }
    case actions.GET_CURRENT_RESTAURANT: {
      const { isShow } = response;
      return {
        ...state,
        isChangeRestaurant: isShow,
      };
    }

    case actions.SET_RING_BELL: {
      const { isRingBell, ringBellSound } = action.response;
      return {
        ...state,
        notificationBell: {
          ...state.notificationBell,
          isRingBell,
          ringBellSound,
        },
      };
    }

    case actions.SET_NOTIFICATION_BELL: {
      const { notification } = action.response;
      const { listNotifications } = state.notificationBell;
      return {
        ...state,
        notificationBell: {
          ...state.notificationBell,
          listNotifications: [
            notification,
            ...listNotifications
              .filter(noti => noti.orderCode !== notification.orderCode)
              .slice(0, 29),
          ],
        },
      };
    }

    case actions.REMOVE_NOTIFICATION_BELL: {
      const { notificationId, orderCode } = action.response;
      const listNotifications = [
        ...state.notificationBell.listNotifications.filter(
          notification =>
            notification.id !== notificationId &&
            notification.orderCode !== orderCode,
        ),
      ];
      return {
        ...state,
        notificationBell: {
          ...state.notificationBell,
          listNotifications,
        },
      };
    }

    case actions.SET_VIEWED_NOTIFICATION: {
      const listNotifications = state.notificationBell.listNotifications.map(
        notification => ({ ...notification, isCount: false }),
      );
      return {
        ...state,
        notificationBell: {
          ...state.notificationBell,
          listNotifications,
          isRingBell: false,
        },
      };
    }

    case actions.SET_RING_ALL_RESTAURANT: {
      const { isRingAllRestaurant } = action.response;
      return {
        ...state,
        notificationBell: {
          ...state.notificationBell,
          isRingAllRestaurant,
        },
      };
    }

    default:
      return state;
  }
}

export default settingsReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/Setting/reducers.js